import React, {useState, useMemo} from 'react';
import PropTypes from 'prop-types';
import RouteUtils from 'services/RouteUtils';
import View from './view.jsx';
import TaskUtils from "services/TaskUtils";
import {useAppSelector} from "careand-redux/store";
import {useAppDispatch} from "careand-redux/useAppDispatch";
import {api} from "careand-redux/api/ApiThunks";
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import {GetStaff} from "careand-redux/selectors";

const TaskBadge = ({hidePatient, task, onClick}) => {

  const dispatch = useAppDispatch();
  const nav = useNavStack(Stacks.Master)

  const patient = useAppSelector(state => state.patients.byId[task.patient_id]);
  const ownId = useAppSelector(state => state.authentication.user.id);

  const assignedUser = useAppSelector(state => GetStaff(state, task.assigned_user_id, false));
  const createdBy = useAppSelector(state => GetStaff(state, task.author_id, false));

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const isAssignedToMe = assignedUser && ownId === assignedUser.id;
  const isCreatedByMe = createdBy && ownId === createdBy.id;
  const isUnassigned = task.assigned_user_id === 'none';

  const canComplete = !loading && (isAssignedToMe || isCreatedByMe || isUnassigned);
  const canArchive = !task.archived && !loading && (isAssignedToMe || isCreatedByMe || isUnassigned);

  async function toggleTaskStatus() {
    let originalStatus = task.status;
    await updateTaskWrapper({...task, status: !originalStatus});
  }

  async function updateTaskWrapper(updatedTask) {
    setLoading(true);
    let task = await dispatch(api.Tasks.updateTask({id: updatedTask.id, task: updatedTask}), {errorTitle: 'Task'});
    setLoading(false);
    return task;
  }

  async function archive() {
    setLoading(true);
    await dispatch(api.Tasks.archiveTask({id: task.id}));
    setLoading(false);
  }

  async function onClaim() {
    await updateTaskWrapper({...task, assigned_user_id: ownId});
  }

  function onTitleClick() {
    if (!!onClick) return onClick(task);
    openEditModal(true);
  }

  function goToPatientProfile() {
    let route = RouteUtils.getRoute(RouteUtils.routes().patient, {
      ':patientId': patient.id,
    });
    nav.push(route);
  }

  function openEditModal(value) {
    setEditModal(value);
  }

  const unreadComments = useMemo(() => TaskUtils.getUnreadComments(task, ownId), [task, ownId]);
  const isUnread = useMemo(() => !(task.read_by || []).includes(ownId),[task, ownId]);

  return (
    <View
      task={task}
      hidePatient={hidePatient}
      patient={patient}
      assignedUser={assignedUser}
      createdBy={createdBy}
      editModal={editModal}
      openEditModal={openEditModal}
      editable={canComplete && !loading}
      onTitleClick={onTitleClick}
      onToggleStatus={canComplete ? toggleTaskStatus : undefined}
      onArchive={canArchive ? archive : undefined}
      onClickPatient={goToPatientProfile}
      isUnassigned={isUnassigned}
      onClaim={onClaim}
      unreadComments={unreadComments}
      isUnread={isUnread}
    />
  );
};

TaskBadge.propTypes = {
  task: PropTypes.object.isRequired,
  hidePatient: PropTypes.bool,
  onClick: PropTypes.func
};

export default TaskBadge
